import axios from 'axios'
import { getRestApiConfig } from '../config'
import { ApiAddress, ApiContracts } from './types'

export const getContracts = async (): Promise<ApiContracts[]> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`/api/v1/Contracts`, restApiConfig.baseUrl).href
    const response = await axios.get<ApiContracts[]>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return response.data
}

export const getAddresses = async (search?: string): Promise<ApiAddress[]> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`api/v1/Addresses?zip=${search}`, restApiConfig.baseUrl).href
    const response = await axios.get<ApiAddress[]>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return response.data
}

export const getStreets = async (search?: string, city?: string, zip?: string): Promise<string[]> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`api/v1/Addresses/Streets?street=${search}&city=${city}&zip=${zip}`, restApiConfig.baseUrl).href
    const response = await axios.get<string[]>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return response.data
}
